import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDl36vjS3wreobViZMg6yVZLkfVr050vvw",
  authDomain: "student-residences.firebaseapp.com",
  projectId: "student-residences",
  storageBucket: "student-residences.firebasestorage.app",
  messagingSenderId: "56444151576",
  appId: "1:56444151576:web:914e9c9d5924707c85e06d",
  measurementId: "G-TBZ8Y0HCN7",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const firestore = getFirestore(app);
const analytics = getAnalytics(app);

export { analytics, firestore };
